import { render, staticRenderFns } from "./Tbs.vue?vue&type=template&id=0b44b4d5&scoped=true&"
import script from "./Tbs.vue?vue&type=script&lang=js&"
export * from "./Tbs.vue?vue&type=script&lang=js&"
import style0 from "./Tbs.vue?vue&type=style&index=0&id=0b44b4d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b44b4d5",
  null
  
)

export default component.exports